/* Global imports. */
import React from "react";
import { Link } from "gatsby";

interface Props {
  title: string;
  link: string;
  linkText?: string;
  imageUrl?: string;
  componentHeading?: string;
  hideImage: Boolean;
  componentID?: string
  referringSlug?: string;
}

const DontMiss = ({ title, link, linkText, imageUrl, componentHeading, hideImage, componentID, referringSlug }: Props) => {
  
  const backgroundImageStyle={
    backgroundImage: `url("${imageUrl}")`
  }

  return <div data-component="dont-miss" id={componentID} className="grid clear-both grid-cols-12 pt-8 pb-8 mt-8 mb-8 sm:gap-8 border-y border-gray">
    {!hideImage && imageUrl && <div 
    className={`mb-4 col-span-full sm:col-span-4 sm:mb-0 bg-[#D9D9D9] bg-cover bg-no-repeat bg-center h-72 sm:h-auto`} 
    style={backgroundImageStyle}
     />}
    
    <div className={!hideImage ? "col-span-full sm:col-span-8" : "col-span-full"}>
      <p className="font-sans !text-sm uppercase text-red">{componentHeading}</p>
      <h3 className="!mb-4 !mt-0 !text-[1.25rem]">{title}</h3>
      {link && <Link className="button" data-ref-slug={referringSlug} to={link}>{linkText !== "" ? linkText : "Read more"}</Link>}
    </div>
  </div>;
}
export default DontMiss;
